export default {
    data() {
        return {
            isModalVisivel: false
        }
    },

    methods: {
        fecharModal() {
            this.isModalVisivel = false;
        },
    }
}